import React, { useState } from "react";
import './FAQ.css';
import faqBg from '../assets/background/Faq.jpg';

const FAQ = () => {
  const [openItems, setOpenItems] = useState(new Set());

  const toggleItem = (index) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(index)) {
      newOpenItems.delete(index);
    } else {
      newOpenItems.add(index);
    }
    setOpenItems(newOpenItems);
  };

  const faqData = [
    {
      question: "Who is my supervisor?",
      answer: "All incoming students are initially assigned to the Program Chair."
    },
    {
      question: "Who supervises my final project?",
      answer: "The supervisor is usually determined in the second year of the program. The Program Chair is assigned as the supervisor unless or until the student finds a supervisor who matches their interests. Depending on their research interest, students may seek any departmental faculty member to supervise their final project, although it is usually someone in Social Psychology."
    },
    {
      question: "How do I apply for work terms?",
      answer: "The application process is organized and administered by the co-op coordinator, who meets with students early in their first semester to provide the details for the process."
    },
    {
      question: "When do I start working on my final project?",
      answer: "Although the project is completed in Academic Term 4, students are encouraged to begin working on their project as soon as they have determined their interest and have supervision in place. This is normally early in the second year of the program or at the end of their first year."
    },
    {
      question: "Is this program only about program evaluation?",
      answer: "No. This program is designed to transfer psychological knowledge and research skills to real world settings so that graduates can conduct research across a range of settings to make evidence-based decisions and policies. Program evaluation is but one aspect of these more general research tools."
    },
    {
      question: "What are the chances of getting a work term?",
      answer: "Excellent. In recent years, all of our students have obtained placements."
    },
    {
      question: "What are the chances of getting a job?",
      answer: "Great. In recent years, all of our students have obtained positions in a range of work place settings, such as the Provincial Government (e.g., Department of Health, Department of Transportation and Work, Treasury Board), Federal Government (e.g., Statistics Canada, Immigration & Refugees), Atlantic Canada Opportunities Agency (ACOA), Research Development Corporation (RDC), Goss-Gilroy Consulting, Market Quest, M5 Marketing, a wide range of community organizations (e.g., Stella's Circle, Community Services Council, Kids Lunch Program, Emmanuel House), and others."
    },
    {
      question: "Can I find my own work terms?",
      answer: "Yes. In fact, we encourage you to find work terms that match your interest. Note, however, that the placement must be approved by the co-op coordinator and the program chair."
    },
    {
      question: "Do the work terms have to be in Newfoundland and Labrador?",
      answer: "No. In fact, we encourage you to consider work terms in other provinces that broaden your experience and interests. We have had many students successfully complete work terms in other provinces."
    },
    {
      question: "How much money will I make on a work term?",
      answer: "It depends on the placement. The amount of financial compensation for each work term varies. On average, students earn approximately $6,000 to $7,500 for a work term."
    },
    {
      question: "How long are the work terms?",
      answer: "Work terms require a minimum of 12 weeks, but are more usually 16 weeks."
    },
    {
      question: "What is the minimum grade needed to pass a course?",
      answer: "A minimum grade of 65% is required to pass all graduate courses. Work terms are graded as: pass or fail."
    },
    {
      question: "How is the final project evaluated?",
      answer: "The final project is evaluated by the program chair and one other faculty member. The evaluation rubric is similar to that of a thesis."
    },
    {
      question: "Can I work full time while completing Academic Term 4?",
      answer: "No. Graduate student regulations stipulate that students can work a maximum of 24 hours per week during any given term."
    },
    {
      question: "How many students are accepted each year?",
      answer: "The number varies from year to year. In recent years, cohort sizes have ranged from 6-10 students, to a maximum of 12. Acceptance into the program is competitive and based largely on academic excellence (e.g., GPA, GRE Scores). Students must also have an interest in conducting research in applied settings."
    },
    {
      question: "Can work terms and academic terms be taken in any order?",
      answer: "No. The program must be completed in the sequence outlined under the Program of Study."
    },
    {
      question: "Do you need an honours degree?",
      answer: "Yes."
    }
  ];

  return (
    <>
      {/* Hero Section */}
      <section className="faq-hero">
        <div className="hero-background">
          <img src={faqBg} alt="" />
        </div>
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="content">
            <div className="hero-text">
              <div className="padding">
                <h1>Frequently Asked Questions</h1>
                <h2>Everything You Need to Know</h2>
                <p>Find answers to the most common questions about the MPSc program, admissions, work terms, and more.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <div className="faq-content">
            <div className="faq-header">
              <h2>Common Questions</h2>
              <p>Click on any question to see the answer</p>
            </div>
            
            <div className="faq-list">
              {faqData.map((item, index) => (
                <div key={index} className={`faq-item ${openItems.has(index) ? 'open' : ''}`}>
                  <button 
                    className="faq-question"
                    onClick={() => toggleItem(index)}
                  >
                    <span>{item.question}</span>
                    <i className={`fas fa-chevron-${openItems.has(index) ? 'up' : 'down'}`}></i>
                  </button>
                  <div className="faq-answer">
                    <p>{item.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQ; 